"use strict";

require("core-js/modules/es.date.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.initConversionEventListener = initConversionEventListener;
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function get() {
    return _package.version;
  }
});

var _qs = _interopRequireDefault(require("qs"));

var _constants = require("./constants");

var _utils = require("./utils");

var _package = require("../package.json");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var widgetCount = 1;
var PAGE_SESSION_ID = (0, _utils.uuidv4)();

function getWidgetWrapperStyles(_ref) {
  var isWidgetBorderHidden = _ref.isWidgetBorderHidden,
      _ref$widgetColorOverr = _ref.widgetColorOverrides,
      widgetBackground = _ref$widgetColorOverr.widgetBackground,
      _ref$widgetColorOverr2 = _ref$widgetColorOverr.widgetBorderRadius,
      widgetBorderRadius = _ref$widgetColorOverr2 === void 0 ? '10px' : _ref$widgetColorOverr2,
      _ref$widgetColorOverr3 = _ref$widgetColorOverr.widgetBoxShadow,
      widgetBoxShadow = _ref$widgetColorOverr3 === void 0 ? '1px 0px 10px -2px #323232' : _ref$widgetColorOverr3,
      _ref$widgetColorPalet = _ref.widgetColorPaletteName,
      widgetColorPaletteName = _ref$widgetColorPalet === void 0 ? 'default' : _ref$widgetColorPalet;
  var borderStyles = isWidgetBorderHidden ? '' : "border-radius: ".concat(widgetBorderRadius, "; box-shadow: ").concat(widgetBoxShadow, ";");
  return "".concat(borderStyles, "\nbackground: ").concat(widgetBackground || _constants.WIDGET_BACKGROUND_BY_PALETTE_NAME[widgetColorPaletteName], ";\noverflow: hidden;\n\nmax-width: ").concat(_constants.DEFAULT_MAX_WIDTH, ";\nwidth: 100%;\nheight: ").concat(_constants.DEFAULT_HEIGHT, ";\n-webkit-backface-visibility: hidden;\n-webkit-transform: translate3d(0, 0, 0);");
}

function generateIframe(_ref2) {
  var src = _ref2.src,
      _ref2$isWidgetBorderH = _ref2.isWidgetBorderHidden,
      isWidgetBorderHidden = _ref2$isWidgetBorderH === void 0 ? false : _ref2$isWidgetBorderH,
      widgetColorOverrides = _ref2.widgetColorOverrides,
      widgetColorPaletteName = _ref2.widgetColorPaletteName; // setup all the attributes on the iframe

  var iframe = document.createElement('iframe');
  iframe.setAttribute('allowtransparency', 'true');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('width', '100%');
  iframe.setAttribute('height', '100%');
  iframe.setAttribute('src', src);
  iframe.setAttribute('tabindex', 0);
  iframe.setAttribute('title', 'BuyerZone RFQ Widget');
  iframe.setAttribute('horizontalscrolling', 'no');
  iframe.setAttribute('style', 'border: 0');
  var wrapper = document.createElement('div');
  wrapper.setAttribute('class', 'bzWidget'); // set inline styles on the widget wrapper

  wrapper.setAttribute('style', getWidgetWrapperStyles({
    isWidgetBorderHidden: isWidgetBorderHidden,
    widgetColorOverrides: widgetColorOverrides,
    widgetColorPaletteName: widgetColorPaletteName
  })); // put iframe inside the widget wrapper div

  wrapper.appendChild(iframe); // return wrapped iframe

  return wrapper;
}

function generateWidgetUrl(_ref3) {
  var categoryId = _ref3.categoryId,
      featureKey = _ref3.featureKey,
      isOptInEnabled = _ref3.isOptInEnabled,
      isTest = _ref3.isTest,
      keywordId = _ref3.keywordId,
      pubId = _ref3.pubId,
      _ref3$stage = _ref3.stage,
      stage = _ref3$stage === void 0 ? _constants.STAGES.PROD : _ref3$stage,
      widgetColorOverrides = _ref3.widgetColorOverrides,
      widgetColorPaletteName = _ref3.widgetColorPaletteName,
      widgetSessionId = _ref3.widgetSessionId;
  var urlOrigin = _constants.WIDGET_ORIGIN_URL[stage];
  var optionalFeaturePath = featureKey ? "/".concat(featureKey) : '';
  var baseWidgetUrl = "".concat(urlOrigin).concat(optionalFeaturePath, "/").concat(categoryId, "/widget/").concat(widgetColorPaletteName ? "".concat(widgetColorPaletteName, "/") : '');

  var widgetQueryString = _qs["default"].stringify({
    keywordId: keywordId,
    pubId: pubId,
    pubtype: 3051,
    widgetColorOverrides: widgetColorOverrides,
    widgetColorPaletteName: widgetColorPaletteName,
    isOptInEnabled: isOptInEnabled,
    isTest: isTest,
    widgetHostPage: window.location.href,
    widgetSessionId: widgetSessionId
  }, {
    encode: true,
    indices: false
  });

  var publisherPageQueryString = window.location.search.replace(/^\?/, '&');
  return "".concat(baseWidgetUrl, "?").concat(widgetQueryString).concat(publisherPageQueryString);
}

function loadIframe(widgetNode) {
  var _widgetNode$dataset = widgetNode.dataset,
      pubId = _widgetNode$dataset.bzwidgetPubId,
      categoryId = _widgetNode$dataset.bzwidgetCategoryId,
      _widgetNode$dataset$b = _widgetNode$dataset.bzwidgetColorOverrides,
      bzwidgetColorOverrides = _widgetNode$dataset$b === void 0 ? '{}' : _widgetNode$dataset$b,
      bzwidgetColorPaletteName = _widgetNode$dataset.bzwidgetColorPaletteName,
      keywordId = _widgetNode$dataset.bzwidgetKeywordId,
      _widgetNode$dataset$b2 = _widgetNode$dataset.bzwidgetStage,
      stage = _widgetNode$dataset$b2 === void 0 ? _constants.STAGES.PROD : _widgetNode$dataset$b2,
      featureKey = _widgetNode$dataset.bzwidgetFeatureKey,
      isTest = _widgetNode$dataset.bzwidgetIsTest,
      isOptInEnabled = _widgetNode$dataset.bzwidgetIsOptInEnabled;
  var isWidgetBorderHidden = widgetNode.hasAttribute('data-bzwidget-hide-border');
  var widgetColorOverrides = JSON.parse(bzwidgetColorOverrides);
  var widgetColorPaletteName = bzwidgetColorPaletteName && bzwidgetColorPaletteName.toLowerCase();
  var widgetSessionId = "".concat(PAGE_SESSION_ID, "-widget").concat(widgetCount);
  var widgetUrl = generateWidgetUrl({
    categoryId: categoryId,
    keywordId: keywordId,
    isOptInEnabled: isOptInEnabled,
    isTest: isTest,
    pubId: pubId,
    featureKey: featureKey,
    stage: stage,
    widgetColorOverrides: widgetColorOverrides,
    widgetColorPaletteName: widgetColorPaletteName,
    widgetSessionId: widgetSessionId
  }); // track init with torch

  (0, _utils.torchTrack)({
    event_type: 'widget_init',
    widget_session_id: widgetSessionId,
    page_url: window.location.href,
    app_version: 'V4',
    category_id: categoryId,
    channel: 'Publisher',
    publisher_id: pubId
  }, stage);
  var iframe = generateIframe({
    src: widgetUrl,
    widgetColorOverrides: widgetColorOverrides,
    widgetColorPaletteName: widgetColorPaletteName,
    isWidgetBorderHidden: isWidgetBorderHidden
  });
  widgetNode.parentNode.insertBefore(iframe, widgetNode);
  widgetCount++;
}

function init() {
  // find all nodes that have a data-bzwidget attribute on them
  var widgetNodes = [].slice.call(document.querySelectorAll('[data-bzwidget]')); // this is the es5 compatible equivelent (https://davidwalsh.name/nodelist-array)

  if (!widgetNodes.length) {
    console.warn("bzWidget-loading-ERROR-404 :: bzWidget.init() was called but no DOM elements were found with a \"data-bzwidget\" attribute set on them. This _may_ be caused by calling the bzWidget.init() method more than once (aka after widgets have already been loaded once)");
    return;
  }

  widgetNodes.map(function (widgetNode) {
    var _widgetNode$dataset2 = widgetNode.dataset,
        categoryId = _widgetNode$dataset2.bzwidgetCategoryId,
        _widgetNode$dataset2$ = _widgetNode$dataset2.bzwidgetLazyLoad,
        isLazyLoadedStringBool = _widgetNode$dataset2$ === void 0 ? 'true' : _widgetNode$dataset2$,
        _widgetNode$dataset2$2 = _widgetNode$dataset2.bzwidgetLazyLoadOffset,
        lazyLoadOffset = _widgetNode$dataset2$2 === void 0 ? 200 : _widgetNode$dataset2$2;

    if (!categoryId) {
      console.error("bzWidget-loading-ERROR-500 :: no categoryId was passed. Please ensure that you have the correct value for the data-bzwidget-category-id attribute");
      return null;
    } // convert data attr string value to bool


    var shouldLazyLoad = isLazyLoadedStringBool === 'true'; // check for IntersectionObserver and .remove() support (because IE11)

    if (typeof IntersectionObserver === 'function' && Element.prototype.hasOwnProperty('remove') && shouldLazyLoad) {
      var lazyLoadMarkerDiv = document.createElement('div');
      lazyLoadMarkerDiv.setAttribute('style', "max-width: ".concat(_constants.DEFAULT_MAX_WIDTH, "; width: 100%; height: ").concat(_constants.DEFAULT_HEIGHT, ";"));
      widgetNode.parentNode.insertBefore(lazyLoadMarkerDiv, widgetNode);
      var options = {
        rootMargin: "0px 0px ".concat(lazyLoadOffset, "px 0px")
      };
      var observer = new IntersectionObserver(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
            _ref5$ = _ref5[0],
            isIntersecting = _ref5$.isIntersecting,
            intersectionRatio = _ref5$.intersectionRatio;

        if (isIntersecting || intersectionRatio > 0) {
          loadIframe(widgetNode);
          observer.unobserve(lazyLoadMarkerDiv);
          lazyLoadMarkerDiv.remove();
        }
      }, options);
      observer.observe(lazyLoadMarkerDiv);
    } else {
      loadIframe(widgetNode);
    } // remove the data-bzwidget attr so that a widget instance never gets loaded more than once even if bzWidget.init() is callled multiple times


    widgetNode.removeAttribute('data-bzwidget');
    return null;
  });
}

function postMessageListener(event) {
  var _event$data = event.data,
      eventName = _event$data.eventName,
      quoteId = _event$data.quoteId,
      categoryName = _event$data.categoryName,
      categoryId = _event$data.categoryId;
  var browserEvent;

  if (eventName === 'bzFirstInteraction') {
    browserEvent = new CustomEvent(eventName, {
      detail: {
        categoryName: categoryName,
        categoryId: categoryId
      }
    });
  }

  if (eventName === 'bzConversion') {
    browserEvent = new CustomEvent(eventName, {
      detail: {
        quoteId: quoteId,
        categoryName: categoryName,
        categoryId: categoryId
      }
    });
  }

  if (browserEvent) {
    document.dispatchEvent(browserEvent);
  }
}

function initConversionEventListener() {
  if (typeof window === 'undefined') {
    return;
  } // add custom event polyfill for IE11 support


  (0, _utils.customEventPolyfill)();
  window.addEventListener('message', postMessageListener, false);
}